import { Link } from "react-router-dom";
import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import FooterNew from "@/components/FooterNew";
import { ERP_PILLAR_ENABLED } from "@/data/automacaoServices";
import retrato from "@/assets/eliveuton.webp";

const principios = [
  {
    title: "Diagnóstico antes de proposta",
    body: "Nunca mando orçamento sem entender o processo. Se automatizar não for o próximo passo certo pra você, eu digo — e não cobro por isso.",
  },
  {
    title: "Você é dono do que eu entrego",
    // TEMP: Odoo oculto — ver docs/specs/temporary-changes.md
    body: `Código do site e do sistema fica com você. Na automação, base open source (Twenty, Chatwoot, ${ERP_PILLAR_ENABLED ? "Odoo, " : ""}n8n): sem mensalidade por usuário, sem lock-in, rodando na sua infraestrutura.`,
  },
  {
    title: "Entrega em etapas, não em 6 meses",
    body: "Projeto longo é projeto que morre no meio. Corto em etapas curtas, com algo funcionando no fim de cada uma.",
  },
  {
    title: "Treino a equipe, não só o sistema",
    body: "Sistema que ninguém sabe usar é o mesmo que planilha. Treinamento e acompanhamento dos primeiros ciclos estão sempre inclusos.",
  },
];

const stack = [
  "React",
  "TypeScript",
  "Node",
  "Supabase",
  "Postgres",
  "n8n",
  "Odoo",
  "Chatwoot",
  "Twenty",
  "OpenAI",
].filter((s) => s !== "Odoo" || ERP_PILLAR_ENABLED);

const Sobre = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOMeta
        title="Sobre"
        description="Conheça Eliveuton Souza, desenvolvedor especializado em sites, sistemas e automação com IA para pequenas e médias empresas."
        canonicalUrl="/sobre"
      />
      <NavbarNew />

      <main>
        <div className="mx-auto max-w-[860px] px-8 pb-[90px] pt-[76px] max-[900px]:px-5">
          <div className="grid grid-cols-[1.2fr_.8fr] items-start gap-11 max-[900px]:grid-cols-1">
            <div>
              <h1 className="text-[42px] font-bold leading-[1.1] tracking-[-0.04em] [text-wrap:balance] max-[900px]:text-[38px]">
                Eu entrego o que a maioria só vende como consultoria
              </h1>
              <p className="mt-[22px] text-[16.5px] leading-[1.75] text-muted-foreground">
                Sou desenvolvedor fullstack e trabalho há seis anos com empresas que cresceram mais
                rápido que o processo delas. Faço três coisas: site que traz cliente, sistema sob
                medida que tira a operação da planilha e automação com IA no atendimento e nas
                vendas. Não vendo PowerPoint de transformação digital: eu construo, coloco no ar e
                fico até a equipe estar usando.
              </p>
              <p className="mt-[18px] text-[16.5px] leading-[1.75] text-muted-foreground">
                Tudo que eu entrego é seu por um motivo simples: você não fica preso a mensalidade
                por usuário nem dependente de mim. Se um dia quiser levar o projeto para outro time,
                leva — com a documentação junto.
              </p>

              <div className="mt-[34px] flex flex-col gap-4">
                {principios.map((p) => (
                  <div
                    key={p.title}
                    className="rounded-2xl border border-border bg-card px-[22px] py-5"
                  >
                    <div className="text-[15px] font-bold tracking-[-0.01em]">{p.title}</div>
                    <p className="mt-2 text-[14px] leading-[1.65] text-muted-foreground">
                      {p.body}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <div className="aspect-[4/5] overflow-hidden rounded-[18px] border border-border bg-muted">
                <img
                  src={retrato}
                  alt="Eliveuton Souza no escritório"
                  width={800}
                  height={1000}
                  decoding="async"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="rounded-2xl border border-border bg-card p-[22px]">
                <div className="text-[11.5px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
                  Stack de trabalho
                </div>
                <div className="mt-[14px] flex flex-wrap gap-[7px]">
                  {stack.map((s) => (
                    <span
                      key={s}
                      className="rounded-lg bg-muted px-[11px] py-1.5 text-xs font-semibold text-muted-foreground"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
              <Link
                to="/contato"
                className="inline-flex h-12 items-center justify-center rounded-full bg-primary text-[14px] font-bold text-primary-foreground transition hover:brightness-95"
              >
                Conversar comigo
              </Link>
            </div>
          </div>
        </div>
      </main>

      <FooterNew />
    </div>
  );
};

export default Sobre;
